export default "__VITE_ASSET__vOcnEbTy__"